export const parseDeviceToUpdate = (deviceSelected) => {
    return {
        DeviceId: deviceSelected.deviceId,
        DeviceDescription: deviceSelected.deviceDescription,
    };
}
